import Skeleton from "@material-ui/lab/Skeleton";
import { Box } from "@mui/material";
import { isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ProfileDetailsCard, TextView } from "../../components";
import AiWheelProgressBar from "../../components/AiWheelProgressBar";
import IOSSwitch from "../../components/IOSSwitch";
import Navbar from "../../components/Navbar";
import AllBusinessBoxes from "../../components/NewBusinessBox/AllBusinessBoxes";
import BusinessBoxPreview from "../../components/NewBusinessBox/BusinessBoxPreview";
import NewWheelPopup from "../../components/NewWheelPopup";
import {
  getUserProfileByIdAction,
  getUserWheelsAction,
} from "../../redux/actions";
import {
  useCreateBusinessBoxProfile,
  useGetBusinessBox,
} from "../../services/mutations";
import { useGetPrimaryBusinessBox } from "../../services/queries";
import ToastMessage from "../../sharedcomponents/Toast";
import { colors } from "../../utils";
import { ASSETS, TOAST_TYPE } from "../../utils/config";
import { getLoggedInUser } from "../../utils/helpers";
import { localStorageHelper } from "../../utils/localStorageHelper";
import "./profile.css";
import * as Styled from "./styles";
import WheelsSection from "./WheelsSection";
import { getUserBgWallpapersAction } from "../../redux/actions/wallpapers";

const Profile = () => {
  const [openWheelPopup, setOpenWheelPopup] = useState(false);
  const { userid } = useParams();

  const publicRef = useRef(null);
  const privateRef = useRef(null);
  const clonesRef = useRef(null);
  const unlockRef = useRef(null);

  const nav = useNavigate();
  const dispatch = useDispatch();

  const { userProfile: profiledata, loading: profileAPiLoading } = useSelector(
    (state) => state.userProfile
  );
  const { userWheels } = useSelector((state) => state.userWheels);

  const isMyProfile = profiledata?.user_id === getLoggedInUser()?.id;

  const handleCloseWheelPopup = () => {
    setOpenWheelPopup(false);
  };

  useEffect(() => {
    if (getLoggedInUser()?.id) {
      const id = userid || getLoggedInUser()?.id;
      if (userid && userid != getLoggedInUser()?.id) {
        nav(`/otheruserprofile/${id}`);
        return;
      }

      dispatch(getUserProfileByIdAction(id));
      dispatch(getUserWheelsAction(id));

      getBusinessBoxData();
    } else {
      if (userid) {
        nav(`/otheruserprofile/${userid}`);
      } else {
        nav("/login");
      }
    }
  }, [userid]);

  useEffect(() => {
    localStorageHelper.setAItokenLeft(profiledata?.tokens_left);
  }, [profiledata]);

  const {
    data: primaryBusinessBoxData,
    isLoading: primaryBusinessBoxLoading,
    refetch: refetchPrimaryBusinessBox,
  } = useGetPrimaryBusinessBox(userid || getLoggedInUser()?.id);

  const [isLoadingBusinessBox, setIsLoadingBusinessBox] = useState(
    primaryBusinessBoxLoading
  );
  const [businessBoxes, setBusinessBoxes] = useState([]);
  const [loadMoreBB, setLoadMoreBB] = useState(
    !isEmpty(primaryBusinessBoxData?.data)
  );
  const [selectedBoxCardData, setSelectedBoxCardData] = useState(
    primaryBusinessBoxData?.data
  );
  const [hideFromProfile, setHideFromProfile] = useState(false);

  useEffect(() => {
    setIsLoadingBusinessBox(primaryBusinessBoxLoading);
    setSelectedBoxCardData(primaryBusinessBoxData?.data);
    setHideFromProfile(primaryBusinessBoxData?.data?.is_visible);
    setLoadMoreBB(!isEmpty(primaryBusinessBoxData?.data));
  }, [primaryBusinessBoxLoading, primaryBusinessBoxData]);

  const getBusinessBox = useGetBusinessBox();
  const createProfileBusinessBox = useCreateBusinessBoxProfile();

  const getBusinessBoxData = () => {
    setIsLoadingBusinessBox(true);
    var id = userid || getLoggedInUser()?.id;

    getBusinessBox.mutate(
      { userid: id },
      {
        onSuccess: (response) => {
          if (response?.status === 200) {
            setBusinessBoxes(response?.data?.results);
            setIsLoadingBusinessBox(false);
          }
        },
        onError: (err) => {
          console.log("getBusinessBox Error:::", err);
          setIsLoadingBusinessBox(false);
        },
      }
    );
  };

  const handleBusinessBoxSelect = (business_box, isFirstBbox, isToggle) => {
    setIsLoadingBusinessBox(true);
    createProfileBusinessBox.mutate(business_box, {
      onSuccess: (response) => {
        console.log("SUCCESS:::", response);
        setIsLoadingBusinessBox(false);
        if (isFirstBbox || isToggle) {
          refetchPrimaryBusinessBox();
        }
      },
      onError: (err) => {
        console.log("Error:::", err);
        setIsLoadingBusinessBox(false);
      },
    });
  };

  const handleFirstBbox = (bbox) => {
    handleBusinessBoxSelect(bbox, true);
    setSelectedBoxCardData(bbox);
    setLoadMoreBB(true);
  };

  const handleToggleHideBbox = (e) => {
    const newVisibility = e.target.checked;
    setHideFromProfile(newVisibility);

    if (selectedBoxCardData) {
      handleBusinessBoxSelect({
        ...selectedBoxCardData,
        is_visible: newVisibility,
      });
    } else {
      handleBusinessBoxSelect({
        ...primaryBusinessBoxData?.data,
        is_visible: newVisibility,
      });
    }
  };

  const handleApplyBboxEverywhere = (event) => {
    const newCheckBoxValue = event.target.checked;

    handleBusinessBoxSelect({
      ...selectedBoxCardData,
      is_base: newCheckBoxValue,
    });
  };

  const scrollToPublic = () => {
    publicRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToPrivate = () => {
    privateRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToClones = () => {
    clonesRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToUnlock = () => {
    unlockRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const [message, setMessage] = useState("");

  const handleToastCloseCallback = () => {
    setMessage("");
  };

  return (
    <>
      <Navbar />
      <Styled.Tab>
        <Styled.TabItem onClick={scrollToPublic}>
          <Styled.TabIcon src={ASSETS.tabGallery} />
          Public
        </Styled.TabItem>
        <Styled.TabItem onClick={scrollToPrivate}>
          <Styled.TabIcon src={ASSETS.tabPrivate} />
          Private
        </Styled.TabItem>
        <Styled.TabItem onClick={scrollToClones}>
          <Styled.TabIcon src={ASSETS.tabClone} />
          Clones
        </Styled.TabItem>
      </Styled.Tab>

      <Styled.Wrapper>
        <Styled.LeftColumn>
          <ProfileDetailsCard
            profileImg={profiledata?.profile_image}
            name={profiledata?.first_name + " " + profiledata?.last_name}
            desc={profiledata?.bio}
            sub={profiledata?.username}
            following={profiledata?.followings}
            followers={profiledata?.followers}
            editicon={ASSETS.edit}
            shareicon={ASSETS.share}
            facebook={ASSETS.facebook_logo}
            twitter={ASSETS.twitter}
            instagram={ASSETS.instagram}
            isLoading={!profiledata && profileAPiLoading}
            profileData={profiledata}
            isEditable={isMyProfile}
          />
          <div style={{ marginTop: 20 }}>
            {isLoadingBusinessBox ? (
              <>
                <Skeleton
                  variant="rect"
                  width={"90%"}
                  height={150}
                  style={{ borderRadius: "20px", margin: "5%" }}
                />
              </>
            ) : (
              <>
                {!isEmpty(primaryBusinessBoxData?.data) ||
                (isEmpty(primaryBusinessBoxData?.data) &&
                  businessBoxes?.length > 0) ? (
                  <>
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <TextView
                        variant="tag"
                        style={{
                          textAlign: "center",
                          color: colors.darkGrey,
                          marginLeft: "20px",
                        }}
                      >
                        Hide business box from my profile
                      </TextView>
                      <IOSSwitch
                        sx={{ m: "1px !important" }}
                        checked={hideFromProfile}
                        onChange={handleToggleHideBbox}
                        colorSwitch={colors.primary}
                      />
                    </Box>
                  </>
                ) : (
                  <></>
                )}
              </>
            )}

            {loadMoreBB ||
            (!isLoadingBusinessBox && businessBoxes?.length === 0) ? (
              <BusinessBoxPreview
                isLoading={isLoadingBusinessBox}
                setIsLoading={setIsLoadingBusinessBox}
                onlyBusinessBox={true}
                noBusinessBox={
                  (primaryBusinessBoxData &&
                    isEmpty(primaryBusinessBoxData?.data)) ||
                  (!isLoadingBusinessBox &&
                    businessBoxes.length === 0 &&
                    isEmpty(primaryBusinessBoxData?.data)) || //NEED confirmation => what happens if primaryBusinessBoxData.data doesnt have anything
                  isEmpty(selectedBoxCardData)
                }
                businessBoxData={selectedBoxCardData}
                refetch={refetchPrimaryBusinessBox}
                handlePopupClick={() => {
                  getBusinessBoxData();
                  setLoadMoreBB(false);
                }}
                PopupType={"load"}
                noEdit={isMyProfile ? false : true}
                handleFirstBbox={handleFirstBbox}
                hideFromProfile={hideFromProfile}
              />
            ) : (
              <AllBusinessBoxes
                showHeader={false}
                businessBoxes={businessBoxes}
                businessBoxApiLoading={isLoadingBusinessBox}
                refetch={getBusinessBoxData}
                refetchPrimaryBusinessBox={refetchPrimaryBusinessBox}
                setOpenPreview={setLoadMoreBB}
                selectedBoxCardData={selectedBoxCardData}
                setSelectedBoxCardData={setSelectedBoxCardData}
                handleBusinessBoxSelect={handleBusinessBoxSelect}
                isEditable={isMyProfile ? true : false}
                handleApplyBboxEverywhere={handleApplyBboxEverywhere}
              />
            )}
          </div>
        </Styled.LeftColumn>
        <Styled.CenterColumn>
          <WheelsSection
            publicRef={publicRef}
            privateRef={privateRef}
            clonesRef={clonesRef}
            setOpenWheelPopup={setOpenWheelPopup}
          />
        </Styled.CenterColumn>
        <Styled.RightColumn>
          <div>
            <AiWheelProgressBar />

            {userWheels?.length ? (
              <div
                className="position-fixed create-wheel d-flex align-items-center flex-column right-0"
                role="button"
                onClick={() => {
                  setOpenWheelPopup(true);
                }}
              >
                <img
                  src={ASSETS.createwheel}
                  alt="Create wheel"
                  className="img-fluid w-75"
                />
                <div className="text-center">
                  Create iYuga <br />
                  Wheel
                </div>
              </div>
            ) : null}
          </div>
        </Styled.RightColumn>
      </Styled.Wrapper>
      <NewWheelPopup
        openWheelPopup={openWheelPopup}
        handleCloseWheelPopup={handleCloseWheelPopup}
      />
      {message && (
        <ToastMessage
          message={message || "Some thing went wrong. Please try again"}
          type={TOAST_TYPE.SUCCESS}
          show={true}
          handleCloseCallback={handleToastCloseCallback}
        />
      )}
      {createProfileBusinessBox?.isError && (
        <ToastMessage
          message={"Something went wrong, Try again !"}
          type={TOAST_TYPE.ERROR}
        />
      )}
      {createProfileBusinessBox?.isSuccess && (
        <ToastMessage
          message={`Business Box has been updated!`}
          type={TOAST_TYPE.SUCCESS}
        />
      )}
    </>
  );
};

export default Profile;
